import configConnect from 'preconf';
import defaults from '../config/default/config.json';

const configure = configConnect(null, defaults);
export { defaults, configure };



// WEBPACK FOOTER //
// ../node_modules/@cube/dcc-widget-v2/src/config.js